$(document).ready(function () {
	const speed = 500;
	
	function backTofirstMap(){
		$('#secondMap').fadeOut(speed, function() {
			$('#firstMap').fadeIn(speed);
		});
		
		$('#menuArea2').fadeOut(speed, function() {
			$('#menuArea1').fadeIn(speed);
		});
	}

	function backToFirstMobileMap(){
		$('#secondMapMobile').fadeOut(speed, function() {
			$('#firstMapMobile').fadeIn(speed);
		});
		
		$('#mobileMenuArea2').fadeOut(speed, function() {
			$('#mobileMenuArea1').fadeIn(speed);
		});
	}
	$('#mapMenuBack1').on('click', function(){
		backTofirstMap();
	});

	$('#mobileMapMenuBack1').on('click', function(){
		backToFirstMobileMap();
	});
	
	function secondMap(){
		$('#firstMap').fadeOut(speed, function() {
			$('#secondMap').fadeIn(speed);
		});
		
		$('#menuArea1').fadeOut(speed, function() {
			$('#menuArea2').fadeIn(speed);
		});
	}

	function secondMapMobile(){
		$('#firstMapMobile').fadeOut(speed, function() {
			$('#secondMapMobile').fadeIn(speed);
		});
		
		$('#mobileMenuArea1').fadeOut(speed, function() {
			$('#mobileMenuArea2').fadeIn(speed);
		});
	}

	$('#benecijaArea').on('click', function(){
		secondMap();
	});

	$('#benecijaAreaMobile').on('click', function(){
		secondMapMobile();
	});

	$('#enter').on('click', function(){
		secondMap();
	});

	$('#enterMobile').on('click', function(){
		secondMapMobile();
	});
	
	function backTosecondMap(){
		$('#menuSub1').fadeOut(speed);
		$('#menuSub2').fadeOut(speed);
		$('#menuSub3').fadeOut(speed);
		var idClass = '.thirdMap';
		if ($('#menuSub1').is(":visible")) {
			idClass = '#thirdMap1';
		}else if ($('#menuSub2').is(":visible")) {
			idClass = '#thirdMap2';
		}else if ($('#menuSub3').is(":visible")) {
			idClass = '#thirdMap3';
		}
		
		$(idClass).fadeOut(speed, function() {
			$('#secondMap').fadeIn(speed);
		});
		
		$('#menuArea3').fadeOut(speed, function() {
			$('#menuArea2').fadeIn(speed);
		});
	}

	function backToSecondMobileMap(){
		$('#mobileMenuSub1').fadeOut(speed);
		$('#mobileMenuSub2').fadeOut(speed);
		$('#mobileMenuSub3').fadeOut(speed);

		var idClass = '.thirdMap';
		if ($('#mobileMenuSub1').is(":visible")) {
			idClass = '#thirdMapMobile1';
		}else if ($('#mobileMenuSub2').is(":visible")) {
			idClass = '#thirdMapMobile2';
		}else if ($('#mobileMenuSub3').is(":visible")) {
			idClass = '#thirdMapMobile3'; 
		}
		
		$(idClass).fadeOut(speed, function() {
			$('#secondMapMobile').fadeIn(speed);
		});
		
		$('#mobileMenuArea3').fadeOut(speed, function() {
			$('#mobileMenuArea2').fadeIn(speed);
		});
	}

	$('#mapMenuBack2').on('click', function(){
		backTosecondMap();
	});

	$('#mobileMapMenuBack2').on('click', function(){
		backToSecondMobileMap();
	});
	
	
	function thirdMap(areaId){
		$('#secondMap').fadeOut(speed, function() {
			$('#thirdMap'+areaId).fadeIn(speed);
		});
		
		$('#menuArea2').fadeOut(speed, function() {
			$('#menuArea3').fadeIn(speed);
			$('#menuSub'+areaId).fadeIn(speed);
		});
	}
	function thirdMapMobile(areaId){
		$('#secondMapMobile').fadeOut(speed, function() {
			$('#thirdMapMobile'+areaId).fadeIn(speed);
		});
		
		$('#mobileMenuArea2').fadeOut(speed, function() {
			$('#mobileMenuArea3').fadeIn(speed);
			$('#mobileMenuSub'+areaId).fadeIn(speed);
		});
	}
	$('#area1').on('click', function(){
		thirdMap(1)
	});
	$('#area1mobile').on('click', function(){
		thirdMapMobile(1)
	});
	$('#area2').on('click', function(){
		thirdMap(2)
	});
	$('#area2mobile').on('click', function(){
		thirdMapMobile(2)
	});
	$('#area3').on('click', function(){
		thirdMap(3)
	});
	$('#area3mobile').on('click', function(){
		thirdMapMobile(3)
	});
	$('#area1Button').on('click', function(){
		thirdMap(1)
	});
	$('#mobileArea1Button').on('click', function(){
		thirdMapMobile(1)
	});
	$('#area2Button').on('click', function(){
		thirdMap(2)
	});
	$('#mobileArea2Button').on('click', function(){
		thirdMapMobile(2)
	});
	$('#area3Button').on('click', function(){
		thirdMap(3)
	});
	$('#mobileArea3Button').on('click', function(){
		thirdMapMobile(3)
	});
	
});